module.exports = __webpack_public_path__ + "src/ts/g.frame.modules/instruments_pack/assets/instruments/tablet/textures/tablet_orm.png";